import { render, staticRenderFns } from "./AdditionaModel.vue?vue&type=template&id=32748758&scoped=true&"
import script from "./AdditionaModel.vue?vue&type=script&lang=js&"
export * from "./AdditionaModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32748758",
  null
  
)

export default component.exports